// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { AppShell } from '@mantine/core';
import { Outlet, useLocation } from 'react-router-dom';
import { FC, useContext, useEffect, useState } from 'react';
import { IconSettings } from '@tabler/icons';
import { WindowContext } from '../../Service/Context/WindowContext';
import DoubleNavbar from '../../Molecules/DoubleNavbar';
import PageHeader from '../Navigation/PageHeader';
import { RoutingS } from '../../Service/RoutingS';
import NavDrawer from '../../Atoms/NavDrawer';
import BookitupFooter from '../Navigation/phone/BookitupFooter';
import SettingsFooter from '../Navigation/phone/SettingsFooter';
import SettingsNavBar from './SettingsNavBar';

const Settings: FC = () => {
  const { sm } = useContext(WindowContext);
  const [drawerOpened, setDrawerOpened] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    RoutingS.changeTitle('Einstellungen');
  }, []);

  return (
    <AppShell
      header={<PageHeader />}
      navbar={
        !sm ? (
          <DoubleNavbar>
            <SettingsNavBar closeNavBar={() => setDrawerOpened(false)} />
          </DoubleNavbar>
        ) : undefined
      }
      styles={(theme) => ({
        main: { backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : 'inherit' },
      })}
      footer={
        sm && pathname.split('/').length <= 3 ? (
          <BookitupFooter>
            <SettingsFooter openNavBar={() => setDrawerOpened(true)} />
          </BookitupFooter>
        ) : undefined
      }
    >
      {sm && (
        <NavDrawer
          label="Einstellungen"
          icon={<IconSettings size={32} />}
          opened={drawerOpened}
          onClose={() => setDrawerOpened(false)}
        >
          <SettingsNavBar closeNavBar={() => setDrawerOpened(false)} />
        </NavDrawer>
      )}
      <Outlet />
    </AppShell>
  );
};

export default Settings;
